import { BaseHttpAdapter } from '~/services/adapters/base-http.adapter';
import { IContractDropdownField } from '~/types/server.types';

export class ContractAdapter extends BaseHttpAdapter {
    async fetchContractFields(flow_id: string) {
        // TODO: use correct url/method
        return this.apiService.apiRequest<IContractDropdownField[]>({
            method: 'get',
            url: `/api/v2/flow/${flow_id}/contract_fields`
        });
    }
}
